class MqaaarStickyAtc extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.sourceForm = document.getElementById(`product-form-${this.sectionId}`);
    this.productInfo = document.getElementById(`ProductInfo-${this.sectionId}`);
    this.button = this.querySelector('[data-sticky-atc-button]');

    if (!this.sourceButton || !this.sourceForm || !this.button) {
      this.remove();
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
      { threshold: 0.15 }
    );
    this.observer.observe(this.sourceButton);

    this.button.addEventListener('click', () => this.handleClick());
    this.syncButtonState();
    this.buttonObserver = new MutationObserver(() => this.syncButtonState());
    this.buttonObserver.observe(this.sourceButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.buttonObserver?.disconnect();
  }

  syncButtonState() {
    const sourceLabel = this.sourceButton.querySelector('span')?.textContent?.trim();
    this.button.textContent = sourceLabel || 'Add to cart';
    this.button.disabled = this.sourceButton.disabled;
    this.button.setAttribute('aria-disabled', String(this.sourceButton.disabled));
  }

  handleClick() {
    if (this.sourceButton.disabled) {
      this.productInfo?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const firstUnselectedOption = this.productInfo?.querySelector('input[type="radio"]:not(:checked)');
      firstUnselectedOption?.focus({ preventScroll: true });
      return;
    }

    this.sourceButton.click();
  }
}

if (!customElements.get('mqaaar-sticky-atc')) {
  customElements.define('mqaaar-sticky-atc', MqaaarStickyAtc);
}
